import React from "react";
import { AdministrationLayoutTemplate } from "themes/administration/common";

function AdministrationLayout(props) {
    return <AdministrationLayoutTemplate {...props} />;
}

export default AdministrationLayout;
